/**
 * Social Feed - Stacking Animation
 * Desktop: Cards stack on top of each other, then unstack on scroll into view
 * Mobile: Swiper slider
 */

let socialFeedSwiper = null;
let socialFeedScrollTriggers = [];

// ═══════════════════════════════════════════════════
// DESKTOP: STACKING ANIMATION
// ═══════════════════════════════════════════════════

function initSocialFeedDesktop() {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
    console.warn('GSAP or ScrollTrigger not loaded. Social feed animation disabled.');
    return;
  }

  const socialFeedSection = document.querySelector('.social-feed-section');
  
  if (!socialFeedSection) return;

  const container = socialFeedSection.querySelector('.social-feed__container');
  const cardsContainer = socialFeedSection.querySelector('.social-feed__cards');
  const cards = socialFeedSection.querySelectorAll('.social-feed__card');

  if (!container || !cardsContainer || cards.length === 0) return;

  // Get the natural layout positions before we move anything
  const cardPositions = [];
  cards.forEach((card) => {
    const rect = card.getBoundingClientRect();
    const containerRect = cardsContainer.getBoundingClientRect();
    cardPositions.push({
      x: rect.left - containerRect.left,
      y: rect.top - containerRect.top
    });
  });

  // Stack position - where all cards will start (at the rightmost card's position)
  const stackPosition = {
    x: cardPositions[cardPositions.length - 1].x,
    y: cardPositions[cardPositions.length - 1].y
  };

  // Set initial stacked state for all cards
  // Set initial stacked state for all cards
cards.forEach((card, index) => {
  // Random rotation for each card (set once at start)
  const randomRotation = (Math.random() * 12 + 8) * (Math.random() < 0.5 ? 1 : -1);
  
  // Store the final position and rotation
  card.dataset.rotation = randomRotation;
  card.dataset.finalX = cardPositions[index].x;
  card.dataset.finalY = cardPositions[index].y;
  
  // Calculate offset from final position to stack position
  const offsetX = stackPosition.x - cardPositions[index].x;
  const offsetY = stackPosition.y - cardPositions[index].y;
  
  // Set initial state: all cards stacked at the same position
  gsap.set(card, {
    x: offsetX,
    y: offsetY + (index * 2), // Tiny vertical offset for visual stacking depth
    rotation: randomRotation, // Top card more opaque
    scale: 0.96,
    zIndex: cards.length - 1 - index // REVERSED: First card = highest z-index (top of stack)
  });
});

  // Create the unstacking animation timeline
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: container,
      start: 'top 60%',
      toggleActions: 'play none none reverse',
      invalidateOnRefresh: true
    }
  });

  // Animate each card from stacked position to final spread-out position
  cards.forEach((card, index) => {
    tl.to(card, {
      x: 0, // Return to natural position (offset of 0)
      y: 0,
      scale: 1,
      duration: 0.8,
      ease: 'power3.out'
    }, index * 0.08); // Stagger: each card starts 0.08s after previous
  });

  socialFeedScrollTriggers.push(tl.scrollTrigger);

  console.log('Social Feed Desktop (Stacking) initialized');
}

// ═══════════════════════════════════════════════════
// MOBILE: SWIPER SLIDER
// ═══════════════════════════════════════════════════

function initSocialFeedMobile() {
  if (typeof Swiper === 'undefined') {
    console.log('Swiper not loaded yet, waiting...');
    setTimeout(initSocialFeedMobile, 100);
    return;
  }

  const swiperContainer = document.querySelector('.social-mobile-slider');
  
  if (!swiperContainer) {
    console.log('Social feed swiper container not found');
    return;
  }

  // Destroy existing instance if it exists
  if (socialFeedSwiper) {
    socialFeedSwiper.destroy(true, true);
    socialFeedSwiper = null;
  }

  socialFeedSwiper = new Swiper('.social-mobile-slider', {
    slidesPerView: 1.155,
    spaceBetween: 16,
    centeredSlides: false,
    grabCursor: true,
    loop: true,
    speed: 400,
    autoplay: true
  });
  
  console.log('Social Feed Mobile (Swiper) initialized');
}

// ═══════════════════════════════════════════════════
// CLEANUP FUNCTIONS
// ═══════════════════════════════════════════════════

function destroySocialFeedDesktop() {
  // Kill all ScrollTriggers
  socialFeedScrollTriggers.forEach(st => {
    if (st) st.kill();
  });
  socialFeedScrollTriggers = [];

  // Reset GSAP transforms
  const cards = document.querySelectorAll('.social-feed__card');
  
  cards.forEach(card => {
    gsap.set(card, { clearProps: 'all' });
  });

  console.log('Social Feed Desktop destroyed');
}

function destroySocialFeedMobile() {
  if (socialFeedSwiper) {
    socialFeedSwiper.destroy(true, true);
    socialFeedSwiper = null;
    console.log('Social Feed Mobile destroyed');
  }
}

// ═══════════════════════════════════════════════════
// RESPONSIVE INIT
// ═══════════════════════════════════════════════════

function initSocialFeed() {
  const isMobile = window.innerWidth <= 768;
  
  if (isMobile) {
    // Mobile: destroy desktop, init mobile
    destroySocialFeedDesktop();
    initSocialFeedMobile();
  } else {
    // Desktop: destroy mobile, init desktop
    destroySocialFeedMobile();
    initSocialFeedDesktop();
  }
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSocialFeed);
} else {
  initSocialFeed();
}

// Re-initialize on window resize
let socialFeedResizeTimer;
window.addEventListener('resize', () => {
  clearTimeout(socialFeedResizeTimer);
  socialFeedResizeTimer = setTimeout(() => {
    initSocialFeed();
    
    // Refresh ScrollTrigger on desktop if needed
    if (window.innerWidth > 768 && typeof ScrollTrigger !== 'undefined') {
      ScrollTrigger.refresh();
    }
  }, 250);
});